import { WebRoutes } from "./WebRoutes";

export const AdminNavRoutes = [
  Object.freeze({ link: WebRoutes.UserHomePage, alias: "Home", icon: "home" }),
  Object.freeze({
    link: WebRoutes.PreregistrationDashboard,
    alias: "Pre-Registration Dashboard",
    icon: "leaderboard",
  },
  ),
  Object.freeze({
    link: "Overview",
    alias: "Overview",
    icon: "fact_check",
    children: [
      {
        link: WebRoutes.ImportOverviewPage,
        alias: "Import",
        icon: "upload_file",
      },
      // { link: WebRoutes.BarcodeOverviewPage, alias: "Barcodes", icon: "article" },
      {
        link: WebRoutes.StatsOverviewPage,
        alias: "Stats",
        icon: "leaderboard",
      },
      {
        link: WebRoutes.BookOverviewPage,
        alias: "Books",
        icon: "auto_stories",
      },
      { link: WebRoutes.SchoolOverviewPage, alias: "Schools", icon: "school" },
      {
        link: WebRoutes.StudentOverviewPage,
        alias: "Students",
        icon: "perm_identity",
      },
    ],
  }),
  Object.freeze({
    link: "Management",
    alias: "Management",
    icon: "work",
    children: [
      {
        link: WebRoutes.IddinkEmployeeHome,
        alias: "Logistics",
        icon: "autorenew",
      },
      {
        link: WebRoutes.SchoolReturns,
        alias: "School flows",
        icon: "qr_code",
      },
      {
        link: WebRoutes.SchoolManagementPage,
        alias: "School Management",
        icon: "school",
      },
    ],
  }),
  Object.freeze({
    link: "Administration",
    alias: "Administration",
    icon: "build",
    children: [
      {
        link: WebRoutes.UsersAdministrationPage,
        alias: "Users",
        icon: "verified_user",
      },
      {
        link: WebRoutes.LogsAdministrationPage,
        alias: "Logs",
        icon: "receipt",
      },
      {
        link: WebRoutes.LanguagesAdministrationPage,
        alias: "Languages",
        icon: "language",
      },
    ],
  }),
  Object.freeze({
    link: WebRoutes.UserProfilePage,
    alias: "Profile",
    icon: "account_circle",
  }),
  Object.freeze({
    link: WebRoutes.Logout,
    alias: "ProfilePageLogOut",
    icon: "logout",
  }),
];

export const StudentsNavRoutes = [
  Object.freeze({
    link: WebRoutes.StudentHomePage,
    alias: "NavHome",
    icon: "home",
  }),
  // Object.freeze({
  //   link: WebRoutes.StudentProfilePage,
  //   alias: "NavProfile",
  //   icon: "account_circle",
  // }),
  Object.freeze({
    link: WebRoutes.InboxPage,
    alias: "NavHelp",
    icon: "help_outline",
  }),
  Object.freeze({
    link: WebRoutes.Logout,
    alias: "ProfilePageLogOut",
    icon: "logout",
  }),
];

export const SchoolNavRoutes = [
  Object.freeze({
    link: WebRoutes.SchoolHomePage,
    alias: "NavHome",
    icon: "home",
  }),
  Object.freeze({
    link: WebRoutes.PreregistrationDashboard,
    alias: "Pre-Registration Dashboard",
    icon: "leaderboard",
  }),
  Object.freeze({
    link: "Overview",
    alias: "Overview",
    icon: "fact_check",
    children: [
      {
        link: WebRoutes.SchoolReturnPage,
        alias: "Returns",
        icon: "book",
      },
      {
        link: WebRoutes.StudentOverviewPage,
        alias: "Students",
        icon: "perm_identity",
      },
    ],
  }),
  Object.freeze({
    link: WebRoutes.SchoolProfilePage,
    alias: "NavProfile",
    icon: "account_circle",
  }),
  Object.freeze({
    link: WebRoutes.InboxPage,
    alias: "NavHelp",
    icon: "help_outline",
  }),
  Object.freeze({
    link: WebRoutes.Logout,
    alias: "ProfilePageLogOut",
    icon: "logout",
  }),
];

export const IddinkEmployeeRoutes = [
  Object.freeze({
    link: WebRoutes.IddinkEmployeeHome,
    alias: "Logistics",
    icon: "autorenew",
  }),
  Object.freeze({
    link: WebRoutes.SchoolManagementPage,
    alias: "School Management",
    icon: "school",
  }
  )
];

export const LogOutRoute = [
  Object.freeze({
    link: WebRoutes.Logout,
    alias: "ProfilePageLogOut",
    icon: "logout",
  }),
];
